import { render, staticRenderFns } from "./Wells.vue?vue&type=template&id=816ea7d2&scoped=true"
import script from "./Wells.vue?vue&type=script&lang=js"
export * from "./Wells.vue?vue&type=script&lang=js"
import style0 from "./Wells.vue?vue&type=style&index=0&id=816ea7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816ea7d2",
  null
  
)

export default component.exports